<template>

    <nav-bar />

    <main-container>

        <div class="row d-flex align-items-center flex-column w-100 h-100">

            <div class="col d-flex justify-content-start flex-column align-items-center m-0 p-0">                                    
                <profile-avatar :username="userName" size="l" class="mb-2"/>                                        
                <h5 class="fw-bold text-center text-uppercase">{{userName}}</h5>                                           
                <h6 class="blue text-center">{{userEmail}}</h6>
                <!-- <span class="red" style="cursor: pointer;" @click="closeSignature">Cancelar Assinatura</span>                                           -->
            </div>

            <div>
                <list-group>
                    <list-item class="list-group-item list-group-item-action px-2" v-on:click="openInNewTab('https://psicoapp.4lions.tec.br/privacy')">
                        <template v-slot:title>
                            <div class="d-flex align-items-center justify-content-center">
                                <font-awesome-icon class="blue fs-5 px-1" :icon="['fas', 'shield']" />
                                <h5 class="mb-0 fw-bold blue">Política de privacidade</h5> 
                            </div>
                        </template>                        
                    </list-item>
                    <list-item class="list-group-item list-group-item-action px-2" v-on:click="openInNewTab('https://psicoapp.4lions.tec.br/terms')">
                        <template v-slot:title>
                            <div class="d-flex align-items-center justify-content-center">
                                <font-awesome-icon class="blue fs-5 px-1" :icon="['fas', 'file-lines']" />
                                <h5 class="mb-0 fw-bold blue">Termos de uso</h5> 
                            </div>
                        </template>                        
                    </list-item>
                </list-group>
            </div>

            <div class="col d-flex align-items-center flex-column justify-content-end">
                <div class="alert alert-warning" role="alert">
                    Ao desconectar seu email não ficará salvo para o próximo login
                </div>
                <button class="btn btn-danger d-flex align-items-center flex-row" v-on:click="logout">
                    <h5 class="m-0 p-0">Desconectar</h5>
                </button>
            </div>            
            
        </div>
                                                        
    </main-container>

    <bottom-bar />

    
</template>


<script>
import { useUserStore } from '../../store/user';
import ProfileAvatar from 'vue-profile-avatar';
import 'sweetalert2/dist/sweetalert2.min.css';
import Swal from "sweetalert2/dist/sweetalert2.js";
export default {
    name:"ConfigsView",
    components:{
        ProfileAvatar
    },
    setup() {
        const userStore = useUserStore();

        return  { userStore }
    },
    beforeMount() {        
        this.userName = this.userStore.getUser.name;
        this.userEmail = this.userStore.getUser.email;
    },
    data() {
        return {
            userName:"",
            userEmail:""            
        }
    },
    methods: {
        logout() {
          localStorage.clear();
          this.$router.push("/login");
        },
        openInNewTab(url) {
            window.open(url, '_blank').focus();
        },
        closeSignature(){
            Swal.fire({
              title: "Atenção!",
              text: "Tem certeza que deseja cancelar sua assinatura do PsicoApp?",
              icon: "warning",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Sim",
              showCancelButton: true,
              cancelButtonText: "Voltar"
            }).then((result) => {
                if(result.isConfirmed){
                    Swal.fire("Sucesso", "Assinatura cancelada", "success");
                }
            });
        }
    }
}
</script>
